import { useContext } from "react";
import appStyles from "../../../App.module.css";
import { CorporateGroupTravelContext } from "../../CorporateGroupTravel";
import cgConstants, { CorporateTravelDocs } from "../../config/cgConstants";
import { ICorporateGroupTravelContext } from "../../config/interfaces";
import LightBulb from "../icons/LightBulb";

const CGOrderDetails = () => {
  const { order } = useContext(CorporateGroupTravelContext) as ICorporateGroupTravelContext;

  const uploadRoaster = () => {
    const _RosterUrl = `${cgConstants.CGRosterUpload}/?order-token=${order?.order_token}`;
    window.open(_RosterUrl, "_blank");
  };
  return (
    <div className={appStyles.CGOrderDetailsContainer}>
      <div className={appStyles.CGOrderDetailsWrap}>
        <div className={appStyles.CGOrderThankHeading}>THANKS FOR YOUR ORDER!</div>
        <div className={appStyles.CGOrderDetailsCard}>
          <div className={appStyles.CGOrderNumberWrap}>
            <span className={appStyles.CGOrderText}>Order Number :</span>
            <span className={appStyles.CGOrderNumber}>{order?.order_number}</span>
          </div>
          <div className={appStyles.CGOrderNumberWrap}>
            <span className={appStyles.CGOrderText}>Plan Number :</span>
            <span className={appStyles.CGOrderNumber}>{order?.items[0]?.policy_number}</span>
          </div>
          <div className={appStyles.CGOrderDetailsThankSub}>
            You'll receive a confirmation email with the plan document and further instructions. <br />
            <br />
            Next Steps:
          </div>
          <ol className={appStyles.CGOrderDetailsList}>
            <li>
              <span className={appStyles.QTFontBold} onClick={uploadRoaster}>
                Visit our Roster submission page&nbsp;
              </span>
              to download the Employee Travel Roster form
            </li>
            <li>Submit your completed form to add a roster to your order</li>
          </ol>
        </div>

        <div className={appStyles.CGOrderDetailsWarning}>
          <LightBulb />
          <p>
            The Employee Travel Roster must be submitted no later than the day before departure. If the roster is not
            received before that date, the plan will be canceled and the plan cost will be refunded.
          </p>
        </div>
        <div className={appStyles.CGOrderDetailsWarning}>
          <LightBulb />
          <p>
            You can make roster changes, additions and deletions up to the day before departure. Contact battleface
            at&nbsp;
            {CorporateTravelDocs.rosterContactNumberUSA_CANADA} (USA/Canada)&nbsp;
            {CorporateTravelDocs.rosterContactNumberInternational} (International) or email at&nbsp;
            {CorporateTravelDocs.rosterContactEmail}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CGOrderDetails;
